import { MatchRepository } from "../repositories/MatchRepository";

export class DeleteTrashUser {
	constructor(private repository: MatchRepository) {}
	execute(user_id: string): Promise<void> {
		return this.repository.deleteTrashUser(user_id);
	}
}
